const VALIDADOR_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

/**
 * Retorna o rótulo de exibição de um destinatário.
 * - Se tiver user_id → usa user.name / user.email do objeto aninhado
 * - Se for livre  → usa name / email do próprio objeto
 */
export const formatarDestinatario = (dest) => {
  if (!dest) return ''
  if (dest.user_id) {
    const u = dest.user
    if (u) return u.name || u.email || `Usuário #${dest.user_id}`
    return `Usuário #${dest.user_id}`
  }
  if (dest.name && dest.email) return `${dest.name} <${dest.email}>`
  return dest.email || dest.name || '—'
}

export const resumirDestinatarios = (lista = []) => {
  if (!Array.isArray(lista) || lista.length === 0) return '-'
  return lista.map(formatarDestinatario).join(', ')
}

const destinatarioValido = (dest) => {
  if (!dest) return false
  if (dest.user_id) return true
  if (!dest.email) return false
  // Aceita e-mail dinâmico (ex: {{responsavel_email}})
  if (/^\{\{\w+\}\}$/.test(dest.email)) return true
  return VALIDADOR_EMAIL.test(dest.email)
}

/**
 * Monta o array `recipients` no formato esperado pelo backend.
 */
export const sanitizarDestinatariosParaPayload = (lista = []) => {
  return (lista || [])
    .filter(destinatarioValido)
    .map((d) => {
      if (d.user_id) {
        return { user_id: Number(d.user_id) }
      }
      return { name: d.name || null, email: d.email }
    })
}
